import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { searchView } from 'api/searchview';
import Spinner from 'components/Spinner/Spinner';
import NewButton from 'components/Button/NewButton';
import { withAsyncCaller } from 'creatella-react-components/lib/HOCs/withAsyncCaller';
import { withThrottledChange } from 'creatella-react-components/lib/HOCs/withThrottledChange';
import OutsideClick from 'creatella-react-components/lib/OutsideClick';
import { ROUTE_PATHS, MODULE_TYPES } from 'config/constants';
import './ModuleSearch.css';

class ModuleSearch extends PureComponent {
    static propTypes = {
        className: PropTypes.string,

        // withAsyncCaller()
        asyncCaller: PropTypes.func.isRequired,

        // withThrottledChange
        onChangeThrottled: PropTypes.func.isRequired
    }

    static defaultProps = {
        className: ''
    }

    constructor(props) {
        super(props);

        this.CALL_ID = 0;
        this.TIMEOUT_SET_LIST = null;
        this.state = {
            isListVisible: false,
            isProcessing: false,
            search: '',
            items: []
        };
    }

    onChangeSearch = (e) => {
        const { onChangeThrottled } = this.props;
        const search = e.target.value;

        this.setState({ search });

        onChangeThrottled(search, this.searchItems);
    }

    searchItems = async (search) => {
        const { asyncCaller } = this.props;
        const CALL_ID = ++this.CALL_ID;

        clearTimeout(this.TIMEOUT_SET_LIST);

        if (!search) {
            this.setState({
                isProcessing: false,
                isListVisible: false,
                items: []
            });

            return;
        }

        this.setState({ isProcessing: true });

        try {
            const { data } = await asyncCaller(searchView, { q: search });

            this.TIMEOUT_SET_LIST = setTimeout(() => {
                this.setList(data, CALL_ID);
            }, 150);
        }
        catch (err) {
            if (err) {
                this.setState({ isProcessing: false });
            }
        }
    }

    setList = (data, callId) => {
        if (this.CALL_ID === callId) {
            this.setState({
                isProcessing: false,
                isListVisible: true,
                items: data
            });
        }
    }

    onClickInput = () => {
        const { isListVisible, search } = this.state;

        if (search) {
            this.setState({ isListVisible: !isListVisible });
        }
    }

    onCloseList = () => {
        this.setState({ isListVisible: false });
    }

    renderItem = (item, index) => {
        const { id, name, type } = item;
        const route = type === MODULE_TYPES.FACTIO
            ? ROUTE_PATHS.FACTIO(id)
            : ROUTE_PATHS.CAMPAIGN(id);

        return (
            <NewButton
                key={index}
                className='ModuleSearch__list-item'
                route={route}>
                {name}
            </NewButton>
        );
    }

    render() {
        const { className } = this.props;
        const { isProcessing, isListVisible, search, items } = this.state;

        return (
            <div className={`ModuleSearch ${className}`}>
                {isProcessing
                    ? <Spinner
                        className='ModuleSearch__spinner'
                        size={20} />
                    : <FontAwesomeIcon
                        className='ModuleSearch__icon'
                        icon={faSearch} />
                }

                <Form.Control
                    className='ModuleSearch__input'
                    placeholder='Rechercher...'
                    value={search}
                    onMouseDown={this.onClickInput}
                    onChange={this.onChangeSearch} />

                {!!(isListVisible && search) && (
                    <OutsideClick
                        className='ModuleSearch__list'
                        onOutsideClick={this.onCloseList}>
                        {items.length
                            ? items.map(this.renderItem)
                            : <div className='ModuleSearch__list-empty'>
                                Rien n'a été trouvé..
                            </div>
                        }
                    </OutsideClick>
                )}
            </div>
        );
    }
}

export default withAsyncCaller(
    withThrottledChange(ModuleSearch)
);
